import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
window.jQuery = $;
//require('foundation-sites');

// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
import './lib/foundation-explicit-pieces'; 
import 'slick-carousel/slick/slick'; 
import 'hc-sticky/dist/hc-sticky';
import 'lazysizes';
import AOS from 'aos'
import slidebars from "exports-loader?slidebars!Slidebars/dist/slidebars.js";
import 'masonry-layout/dist/masonry.pkgd';
import 'imagesloaded/imagesloaded.pkgd';


$(document).foundation();

$(document).ready(function () {

    var direction = $('html').css("direction").toLowerCase() === 'rtl' ? 'right' : 'left';
    var direction_boolean = $('html').css("direction").toLowerCase() === 'rtl'; 

    $("#return-to-top, .scroll-top").click(function () {
        $("body,html").animate({scrollTop: 0}, 500)
    });


    // menu-panel sub-menu toggle
    if (Foundation.MediaQuery.is('medium up') == true ){
        $('.menu-panel .toggle').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            console.log($(this), 'this');
           // $(this).find('i').toggleClass('icon-arrow-down icon-arrow-up');
            $(this).closest('li').toggleClass('expanded');
            $(this).closest("li").find(".menu .animate-sub_js").toggleClass('animate__slideInDown animate__slow');
        });
    }
   

    $('.dropdown-wrapper .dropdown').click(function (e) {
        e.preventDefault();
        e.stopPropagation();
        $('.dropdown-wrapper .dropdown').next().removeClass('expand');
        $(this).next().toggleClass('expand');
    });
    $(document).keyup(function (e) {
        if (e.keyCode == 27) { // escape key maps to keycode `27`
            $('.dropdown-wrapper .dropdown').next().removeClass('expand');
        }
    });
    $(document).click(function (event) {
        if (!$(event.target).closest('.dropdown-wrapper').length) {
            if ($('.dropdown-wrapper .dropdown').next().is(":visible")) {
                $('.dropdown-wrapper .dropdown').next().removeClass('expand');
            }
        }
    });

    $('.searchbox-toggle').on('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        $('body').toggleClass('open-overlay');
        $('.search-overlay-wrapper').find('input[type="text"]').focus();
    });

    $('.close-overlay').on('click', function (e) {
        // $('.searchbox-toggle').removeClass('focused');
        // $('.searchbox-toggle').next().removeClass('open');
        $('body').removeClass('open-overlay');
        // $('.searchbox-toggle').find('i').toggleClass('icon-magnifier icon-circle');
    });

    AOS.init();
  
  
// Initialize Slidebars
//     var controller = new slidebars();
//     controller.init();

//     $(document).on('click', '.toggle-nav-panel', function (event) {
//         // Stop default action and bubbling
//         event.stopPropagation();
//         event.preventDefault();

//         // $('.toggle-nav-panel').find('i').toggleClass('icon-menu icon-close');
//         $('.toggle-nav-panel').toggleClass('is-active');
//         //console.log("panel");
//         // Toggle the Slidebar with id 'id-4'
//         controller.toggle('nav-panel');
//     });

// // Add close class to canvas container when Slidebar is opening
//     $(controller.events).on('opening', function (event) {
//         $('[canvas="container"]').addClass('sb-opening');
//         $('.dropdown-wrapper .dropdown-menu').removeClass('expand')
//     });

// // Add close class to canvas container when Slidebar is opening
//     $(controller.events).on('opened', function (event) {
//         $('[canvas="container"]').addClass('sb-opened');
//     });

// // Remove close class from canvas container when Slidebar is closing
//     $(controller.events).on('closing', function (event) {
//         $('[canvas="container"]').removeClass('sb-opening');
//     });

// // Remove close class from canvas container when Slidebar is closing
//     $(controller.events).on('closed', function (event) {
//         $('[canvas="container"]').removeClass('sb-opened');
//     });

// // Close any
//     $(document).on('click', '#sb-blocker, .close-panel span, .dropdown-wrapper', function (event) { //.sb-opening
//         if (controller.getActiveSlidebar()) {
//             event.preventDefault();
//             event.stopPropagation();
//             controller.close();
//         }
//         $('.toggle-nav-panel').removeClass('is-active');
//         $('.toggle-nav-panel').find('i').removeClass('icon-close');
//         $('.toggle-nav-panel').find('i').addClass('icon-hamburger');
//     });


    // TOGGLE BURGER NAV

    $('.toggle-nav_js').on('click', function() {
        $('.navpanel_js').fadeToggle("slow");
        $('.navpanel_js .animate_js').addClass("animate__slideInUp animate__slow");
    });
    
 
    $('.close-panel_js').on('click', function() {
        //check if there are open submenus
        if ($('.menu-panel li').hasClass("expanded")){
            //if yes, close submenu
            $('.menu-panel li.expanded').find(".menu .animate-sub_js").toggleClass('animate__slideInDown animate__slow');
            $('.menu-panel li.expanded').toggleClass("expanded");
        }

        $('.navpanel_js .animate_js').removeClass("animate__slideInUp").addClass("animate__fadeOutDown"); 
          
        setTimeout(function() {
            $('.navpanel_js').fadeToggle("slow"); 
        }, 250);
    });
    

    if ($('#main-header').length > 0) {
        var stickyBlock = new hcSticky('#main-header', {
            stickTo: '#main-wrap',
            //stickyClass: 'hc-sticky',
            // onStart: function () {
            //     $('.canvas-panel').css('top', $('.main-header-inner').outerHeight());
            // },
            // onStop: function () {
            //     $('.canvas-panel').css('top', $('#main-header').outerHeight());
            // }
        });
    }


    if ($('.sticky-area').length > 0) { 
        var stickySectionTitles = document.getElementsByClassName('sticky-area');
     
        for (var i = 0; i < stickySectionTitles.length; i++) {
            new hcSticky(stickySectionTitles[i], {
                stickTo: stickySectionTitles[i].parentNode,
                top: 80,
                // responsive: {
                //     800: {
                //         disable: true
                //     }
                // }
            });
       
        }
    } 

    $('.masonry-grid_js').each(function(i, obj) {

        var $grid = $(this).masonry({
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
            percentPosition: true,
            transitionDuration: 2,     
           // isAnimated: true
          });
        
        $grid.imagesLoaded().progress( function() {
            $grid.masonry('layout');
        }); 
    }); 
  
    //hero slick slider
    var slideshow = $('.slideshow_js'); 
    if ($(slideshow).length > 0){
        slideshow.slick({
            // lazyLoad: 'ondemand',  
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: false,
            fade: true,
            rtl: direction_boolean,
            autoplay: true
        });

    }

    var gallerySlider = $('.gallery-slider_js'),
        sliderContentHeight;
    if ($(gallerySlider).length > 0){
        gallerySlider.slick({
            lazyLoad: 'ondemand',
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            fade: true,  
            rtl: direction_boolean,
            dots: true,
            adaptiveHeight: true,
            mobileFirst: true,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            swipe: false
                        }
                    }
                ]
        });
    }

    function fixCtrlPosition() { 
        sliderContentHeight = gallerySlider.find('.slick-current .slider-item-caption').outerHeight() || 0;
        // console.log(sliderContentHeight);
        gallerySlider.find('.slick-prev, .slick-next').css({'margin-top': -(sliderContentHeight + 20) / 2});

    }

    gallerySlider.on('setPosition', function (slick) {
        fixCtrlPosition();
    });

    //var figure = $(".video-item").hover( hoverVideo, hideVideo );

    $(".video-item").on({
        mouseenter: function () {
            $('video', this).get(0).play(); 
        },
        mouseleave: function () { 
            $('video', this).get(0).pause(); 
        }
    });

    //share social media button
    $('.share-trigger_js').on('click', function () {
        $('.socials-share').slideToggle();
        $(this).toggleClass('clicked');
    });

    // if (Foundation.MediaQuery.only('small') == true){ 
    //     $('.video-item').each(function(i, obj) {
    //         $('video', this).get(0).play(); 
    //     })
    // }
    
    // function hoverVideo(e) {  
    //     $('video', this).get(0).play(); 
    // }

    // function hideVideo(e) {
    //     $('video', this).get(0).pause(); 
    // }
 

    // $('.mega-menu_js li[data-id]').on({
    //     mouseenter: function () {
    //         $(this).addClass('active'); 
    //         $('.submenu_js[data-id=' + $(this).attr('data-id') + ']').addClass('active');
    //     },
    //     mouseleave: function () { 
    //         $(this).removeClass('active'); 
    //         $('.submenu_js[data-id=' + $(this).attr('data-id') + ']').removeClass('active');
    //     }
    // });

    // $(window).scroll(function() {    
    //     var scroll = $(window).scrollTop();
    //     var scrollSrc = "assets/img/AhlanWaSahlan-LOGO.svg";

    //     if (scroll >= 500) {
    //         $(".main-header-inner").addClass("scrolling");
    //         $(".main-header-before").addClass("scrolling");
    //         // $(".imglogo").attr("src", initialSrc);
    //         $('.hvr-reveal').css('color', '#000');
    //        // document.getElementById("logoimg").src="../assets/img/AhlanWaSahlan-LOGO.svg";
            
    //     } else {
    //         $(".main-header-inner").removeClass("scrolling");
    //         $(".main-header-before").removeClass("scrolling");
    //         $('.hvr-reveal').css('color', '#fff');
    //      //   document.getElementById("logoimg").src="../assets/img/AhlanWaSahlan-LOGO.svg";
            
            
    //     }
    // }); 
    
    function setThemePreference() {
        var d = new Date();
        /*
        * The getHours() method returns the hour (from 0 to 23) of the specified date and time.
        * Early mornig = 0 - 6
        * Morning = 6 - 12
        * Evening = 12 - 18
        * Night = 18 - 23
        */
        var currentHour = d.getHours();  
        
        if(currentHour >= 19 || currentHour <= 6) {
            document.body.setAttribute("data-theme", "dark_theme") 
        }else {
            document.body.setAttribute("data-theme", "light_theme") 
        }
    }

    window.onload = setThemePreference;




    // START:  TRENDING SLIDER

    //Trending slick slider
    var trendingSlider = $('.trending-slide_js'); 
    if ($(trendingSlider).length > 0){
        $.each(trendingSlider, function() {
            $(this).slick({
                dots: false,
                infinite: false,
                speed: 300,
                arrows: false,
                rtl: direction_boolean,
                slidesToShow: 3.4,
                slidesToScroll: 4,
                responsive: [
                //   {
                //     breakpoint: 1024,
                //     settings: {
                //       slidesToShow: 3,
                //       slidesToScroll: 3,
                //       infinite: true,
                //       dots: true
                //     }
                //   },
                  {
                    breakpoint: 769,
                    settings: {
                      slidesToShow: 2.2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      slidesToShow: 1.3,
                      slidesToScroll: 1
                    }
                  } 
                ]
            });
        });

        $(".trending-section .tabs-title a").on("click", function(){
            $(trendingSlider).slick('refresh');
        })
    }

    // END: TRENDING SLIDER


});
